// src/hooks/layout/useConnectionLineLayout.js
// Bağlantı Hattı paftası layout hook'u — stub
import { useRef } from 'react';

export const useConnectionLineLayout = (scenesRef, sceneTabId) => {
  const TARGET_TAB = sceneTabId || 'baglanti';
  const allGroupsRef = useRef([]);
  const boundsRef = useRef({});
  const documentBoundsRef = useRef([]);

  // TODO: Bağlantı Hattı dokümanları burada oluşturulacak
  // scenesRef.current[TARGET_TAB] sahnesi üzerine render edilecek

  return { allGroupsRef, boundsRef, documentBoundsRef };
};
